<div id="cutomer-information-screen" [ngStyle]="{'height.px':divHeight1}">
    <div class="row no-gutters" [ngStyle]="{'height.px':divHeight1}">
        <div class="col-lg-4" id="progresstracker">
            <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneTickIcon]="stepOneTickIcon"
                [stepOneDone]="stepOneDone" [stepTwoInformationpage]="stepTwoInformationpage"
                [stepTwoProfileDone]="stepTwoProfileDone" [stepTwoDone]="stepTwoDone"
                [progressTrackerStatus]="progressTrackerStatus"></app-progress-tracker>
        </div>
        <div class="col-lg-8" id="form-component-section">
            <app-customer-information-form-utf [selectedWorkPlace]="selectedWorkPlace"
                (goToInstantVerification)="goToInstantVerification1($event)"
                (progressTrackerEvent)="handleProgressTrackerEvent($event)"
                (hideSessionTimeout)="setSessionTimeout($event)" (showCancelModal)="cancelModal($event)"
                (clearSessionTimeout)="clearSessionTimeout($event)">
            </app-customer-information-form-utf>
        </div>
    </div>
    <div [ngClass]="showInactivityModal ? 'open-utf-inactivity-modal' : ''">
        <app-customer-inactivity-utf-modal [openModal]="openInactivityModal"
            (closeInactivityModal)="closeInactivityModal($event)">
        </app-customer-inactivity-utf-modal>
    </div>
    <div [ngClass]="showCancelModal ? 'open-utf-cancel-modal' : 'hide-cancel-modal'">
        <app-customer-utf-cancel-modal [openModal]="openCancelModal" (closeCancelModal)="closeModal($event)"
            (setNewSession)="setSessionTimeout($event)">
        </app-customer-utf-cancel-modal>
    </div>
</div>